<template>
  <div>
    <HeroSection />
    <PartnersSection />
    <WebsiteSolution />
    <ProblemSolutionSection />
    <BenefitsSection />
    <DigitalChecklistSection />
    <SolutionsSection />
    <ProcessSection />
    <UseCasesSection />
    <ReviewsSection />
    <FaqSection />
    <CtaSection />
  </div>
</template>

<script setup>
import HeroSection from '../components/HeroSection.vue'
import PartnersSection from '../components/PartnersSection.vue'
import WebsiteSolution from '../components/WebsiteSolution.vue'
import ProblemSolutionSection from '../components/ProblemSolutionSection.vue'
import BenefitsSection from '../components/BenefitsSection.vue'
import DigitalChecklistSection from '../components/DigitalChecklistSection.vue'
import SolutionsSection from '../components/SolutionsSection.vue'
import ProcessSection from '../components/ProcessSection.vue'
import UseCasesSection from '../components/UseCasesSection.vue'
import ReviewsSection from '../components/ReviewsSection.vue'
import FaqSection from '../components/FaqSection.vue'
import CtaSection from '../components/CtaSection.vue'

defineOptions({
  name: 'HomePage'
})
</script>
